'use strict';

(function () {
  // "Papier Cadeau" gift-wrap product variant (€1.50). Using cart/update with the
  // variant id SETS an absolute quantity (1 or 0), so it can never be duplicated.
  var GIFT_WRAP_VARIANT_ID = 54579362824525;

  function updateGiftWrap(enabled) {
    var updates = {};
    updates[GIFT_WRAP_VARIANT_ID] = enabled ? 1 : 0;
    return fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Gift wrap update failed');
      }

      return response.json();
    });
  }

  function updateCartNote(note) {
    return fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        note,
      }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Cart note update failed');
      }

      return response.json();
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-discount-toggle]');
    if (toggle) {
      const panel = document.getElementById('CartDiscountPanel');
      if (!panel) return;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
      return;
    }

    const applyButton = event.target.closest('[data-cart-discount-apply]');
    if (applyButton) {
      const input = document.getElementById('CartDiscountCode');
      const code = input?.value.trim();
      if (!code) return;
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
      return;
    }

    const removeNoteButton = event.target.closest('[data-cart-note-remove]');
    if (removeNoteButton) {
      removeNoteButton.disabled = true;
      updateCartNote('')
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          removeNoteButton.disabled = false;
        });
    }
  });

  document.addEventListener('change', (event) => {
    const giftWrapToggle = event.target.closest('[data-cart-gift-wrap-toggle]');
    if (giftWrapToggle) {
      giftWrapToggle.disabled = true;
      updateGiftWrap(giftWrapToggle.checked)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          giftWrapToggle.disabled = false;
          giftWrapToggle.checked = !giftWrapToggle.checked;
        });
      return;
    }

    const select = event.target.closest('[data-cart-country-select]');
    if (!select) return;

    // The select is linked (via its form="ChCartLocalizationForm" attribute) to the
    // real Shopify localization form, which is rendered OUTSIDE the cart form. So
    // select.form resolves to that localization form (not the cart form), and its
    // submit posts the chosen country to Shopify's correct localization endpoint.
    const localizationForm = select.form;
    if (!localizationForm) return;
    // Do NOT disable the select before submit: it carries name="country_code", and
    // disabled controls are omitted from the POST. The page navigates away anyway.
    localizationForm.submit();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.target.id !== 'CartDiscountCode') return;
    event.preventDefault();
    const code = event.target.value.trim();
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
  });
})();
